export default /* @ngInject */ class {
    constructor(moment) {
        this.moment = moment;
    }

    /**
     * Get the date next month
     *
     * dd-mm-yyy
     * date = 01-01-2016, return 01-02-2016
     * date = 31-01-2016, return 28-02-2016 (last day of month)
     * date = 01-12-2016, return 01-01-2017
     *
     * @param date
     * @returns {Date}
     */
    getDateNextMonth(date) {
        let start = this.moment(date);
        let now = this.moment();
        return now.date(start.date()).add(1, 'month').toDate();
    }
}



// WEBPACK FOOTER //
// ./utils/services/dates.js